import { InjectionToken } from "@angular/core";
import { EmploymentAgreementsPort } from "./employment-agreements.port";

export const EMPLOYMENT_AGREEMENTS_PORT =
  new InjectionToken<EmploymentAgreementsPort>("EMPLOYMENT_AGREEMENTS_PORT");
